import React, { Component } from 'react'
import './result.scss'
import axios from 'axios';
import { httpUrl } from '../../../utils/apiService';
import button_xingxing from '../../../assets/activity/blackFive/button_xing.svg'
import ReviewsList from './reviewsList';
const suo = require('../../../assets/activity/blackFive/suo.png')

class Result extends Component {
  constructor(props) {
    super(props)
    this.state = {
      email: '',
      isValidEmail: false,
      loading: true,
      shortReportDesc: '',
    }
  }

  componentDidMount() {
    // 组件挂载后滚动到页面顶部
    window.scrollTo(0, 0);
    this.getShortReport();
  }
  getShortReport = () => {
    axios({
      method: 'post',
      url: httpUrl + '/api/simple_report',
      data: {
        "email": '',
        "report_type": '1',
        "birthday": this.props.birthday,
        "user_gender": this.props.gender,
        "lat": this.props.lat,
        "long": this.props.long,
      }
    })
      .then(response => {
        this.setState({
          loading: false,
          shortReportDesc: response.data.data.simple_report
        })

      })
      .catch(error => {
        console.error(error);
      });
  }
  getHttp = () => {
    axios({
      method: 'post',
      url: httpUrl + '/api/send_report',
      data: {
        "email": this.state.email,
        "report_type": '1',
        "birthday": this.props.birthday,
        "user_gender": this.props.gender,
        "lat": this.props.lat,
        "long": this.props.long,
      }
    })
      .then(response => {
        this.props.onPopShow(true, this.state.email)
      })
      .catch(error => {
        console.error(error);
      });
  }
  handleEmailChange = (event) => {
    const email = event.target.value;
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const isValidEmail = emailPattern.test(email);
    this.setState({
      email: email,
      isValidEmail: isValidEmail,
    })
  };
  render() {
    const { name, birthday, gender } = this.props; // 从 props 中提取
    document.addEventListener("DOMContentLoaded", function () {
      const reviewsList = document.querySelector(".reviews_list");
      const wrapper = document.createElement("div");
      wrapper.classList.add("reviews_wrapper");

      // 将所有子节点包裹进新容器中
      while (reviewsList.firstChild) {
        wrapper.appendChild(reviewsList.firstChild);
      }
      reviewsList.appendChild(wrapper);

      // 克隆节点用于无缝循环
      const clone = wrapper.cloneNode(true);
      reviewsList.appendChild(clone);

      let scrollPos = 0;

      // 实现向上滚动
      function scroll() {
        scrollPos += 1;
        if (scrollPos >= wrapper.offsetHeight) {
          scrollPos = 0;
        }
        reviewsList.scrollTop = scrollPos;
      }

      setInterval(scroll, 30); // 调整滚动速度（数字越小滚动越快）
    });

    return (
      <div className="result">
        <div className="main">
          <div className="header">
            {/* <div className="sun"></div>
            <div className="planet"></div> */}
            <div className="title">
              Unveiling {name ? name + "'s" : 'Your' + "'s"} <br />
              2025 Horoscope Soon
            </div>
          </div>
          <div className="theme">
            <div className="cw"></div>
            <div className="hf"></div>
            <div className="fl"></div>
          </div>
          <div className='report_top'>
            <img style={{ width: '25px', height: '20px', position: 'absolute', right: '25px' }} src={require('../../../assets/activity/blackFive/short_report_xing.png')} />
            {this.state.loading &&
              <div className='loading_report'>
                <div class="blobs">
                  <div class="blob-center"></div>
                  <div class="blob"></div>
                  <div class="blob"></div>
                  <div class="blob"></div>
                  <div class="blob"></div>
                  <div class="blob"></div>
                  <div class="blob"></div>
                </div>
                <svg xmlns="http://www.w3.org/2000/svg" version="1.1">
                  <defs>
                    <filter id="goo">
                      <feGaussianBlur in="SourceGraphic" stdDeviation="10" result="blur"></feGaussianBlur>
                      <feColorMatrix in="blur" mode="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 18 -7" result="goo"></feColorMatrix>
                      <feBlend in="SourceGraphic" in2="goo"></feBlend>
                    </filter>
                  </defs>
                </svg>
              </div>
            }
            {
              !this.state.loading &&
              <>
                <span className='report_desc'>
                  {this.state.shortReportDesc}
                </span>
                <div className='report_suo'>
                  <img style={{ marginBottom: '20px', width: '23px', height: '25px' }} src={suo} />
                </div>
              </>
            }
          </div>
          <div className="from">
            <input value={this.state.email} onChange={(e) => this.handleEmailChange(e)} type="email" placeholder="Enter your Email" class="email-input" />
            {this.state.isValidEmail &&
              <div className="btn" onClick={this.getHttp}><img style={{ width: '19px', height: '18px', marginRight: '10px' }} src={button_xingxing} />Get right away<img style={{ width: '19px', height: '18px', marginLeft: '10px' }} src={button_xingxing} /></div>
            }
            {!this.state.isValidEmail &&
              <div className="btn_disabled"><img style={{ width: '19px', height: '18px', marginRight: '10px' }} src={button_xingxing} />Get right away<img style={{ width: '19px', height: '18px', marginLeft: '10px' }} src={button_xingxing} /></div>
            }
            <span style={{ width:'100%',textAlign:'center',marginTop:'5px',fontSize:'12px' }}>Get a comprehensive report worth $199 for free now</span>
          </div>
          <ReviewsList />
          <div className="mb45"></div>
        </div>
      </div>
    )
  }
}

export default Result
